import React from "react";
import { useAccount, useNetwork, useSwitchNetwork } from "wagmi";
import { toast } from "react-toastify";
import { parseEther } from "ethers/lib/utils";

import Button from "../../common/button";
import { NFT_PRICE, SUPPORT_CHAINS } from "../../config";
import { ConnectButton } from "./ConnectButton";
import { useNFTContract } from "../../hooks/useNFTContract";

export const MintButton = () => {
  const { address } = useAccount();
  const { chain } = useNetwork();
  const { switchNetwork } = useSwitchNetwork();
  const { isLoading, writeAsync } = useNFTContract();

  const handleMint = async () => {
    toast.promise(
      writeAsync({
        value: parseEther(NFT_PRICE),
      }),
      {
        pending: "NFT is mining",
        success: {
          render({ data }) {
            return "Congratulations on your minted NFT success!";
          },
          icon: "🟢",
        },
        error: {
          render({ data }) {
            return <div>{data.message}</div>;
          },
        },
      }
    );
  };

  if (address && !SUPPORT_CHAINS.map((v) => v.id).includes(chain.id)) {
    return (
      <Button
        lg
        variant="error"
        disabled={isLoading}
        onClick={() => switchNetwork?.(SUPPORT_CHAINS[0].id)}
        className="btn-mint"
      >
        Switch Network
      </Button>
    );
  }

  return !address ? (
    <ConnectButton />
  ) : (
    <Button
      lg
      variant="mint"
      disabled={isLoading}
      onClick={handleMint}
      className="btn-mint"
    >
      {isLoading ? "Mining" : "Mint Now"}
    </Button>
  );
};
